import { CssBaseline } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import { ArchivedProjectCheck } from './components/archivedProjectCheck'
import { FormWidget } from './components/formWidget'
import { Layout } from './components/layout'
import { ListWidget } from './components/listWidget'
import { NotFound } from './components/notFound'
import { ShowingSignupForm as ShowingSignupPage } from './components/showingSignupPage'
import { Signup } from './components/signup'
import { SignupClosed } from './components/signupClosed'
import { SignupUnopened } from './components/signupUnopened'
import { WidgetTheme } from './components/widgetTheme'
import { Theme } from './theme'
import './i18n'

const queryClient = new QueryClient()

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter onUpdate={() => window.scrollTo(0, 0)}>
      <CssBaseline />
      <Switch>
        <Route exact path="/projects/:projectId/list-widget">
          <WidgetTheme>
            <ListWidget />
          </WidgetTheme>
        </Route>
        <Route exact path="/projects/:projectId/form-widget">
          <WidgetTheme>
            <FormWidget />
          </WidgetTheme>
        </Route>
        <Route
          exact
          path="/projekt/:projectId"
          render={({ match, location }) => (
            <Redirect
              to={{
                pathname: `/projects/${match.params.projectId}`,
                search: location.search,
              }}
            />
          )}
        />
        <Route
          exact
          path="/projekt/:projectId/anmalan-stangd"
          render={({ match, location }) => (
            <Redirect
              to={{
                pathname: `/projects/${match.params.projectId}/closed`,
                search: location.search,
              }}
            />
          )}
        />
        <Route
          exact
          path="/projekt/:projectId/anmalan-ej-oppen"
          render={({ match, location }) => (
            <Redirect
              to={{
                pathname: `/projects/${match.params.projectId}/unopened`,
                search: location.search,
              }}
            />
          )}
        />
        <Route>
          <Theme>
            <ArchivedProjectCheck>
              <Switch>
                <Route exact path="/projects/:projectId/closed">
                  <Layout>
                    <SignupClosed />
                  </Layout>
                </Route>
                <Route exact path="/projects/:projectId/unopened">
                  <Layout>
                    <SignupUnopened />
                  </Layout>
                </Route>
                <Route exact path="/projects/:projectId/showings">
                  <Layout>
                    <ShowingSignupPage />
                  </Layout>
                </Route>
                <Route exact path="/projects/:projectId">
                  <Layout>
                    <Signup />
                  </Layout>
                </Route>
                <Route>
                  <NotFound />
                </Route>
              </Switch>
            </ArchivedProjectCheck>
          </Theme>
        </Route>
      </Switch>
    </BrowserRouter>
  </QueryClientProvider>
)
